import type { NormalizedCacheObject } from '@apollo/client';
import { getApolloClientInternal } from './apolloClient';

export function extract(): NormalizedCacheObject {
    return getApolloClientInternal().cache.extract();
}
